import { AssetCategoryWithElementsType } from './types';

// Art
const SKILL_CROCHETING = 'Crocheting';
const SKILL_KNITTING = 'Knitting';
const SKILL_SCULPTING = 'Sculpting';

const ART_LABEL = 'Art';

const SKILLS_ART = [
  'Artist',
  SKILL_CROCHETING,
  SKILL_KNITTING,
  SKILL_SCULPTING,
];

const SKILLS_ART_UK = [
  SKILL_CROCHETING,
  SKILL_KNITTING,
  SKILL_SCULPTING,
  'Painting',
  'Sketch',
];

const SKILLS_ART_CATEGORY = {
  label: ART_LABEL,
  list: SKILLS_ART,
};

const SKILLS_ART_CATEGORY_UK = {
  label: ART_LABEL,
  list: SKILLS_ART_UK,
};

// Dance
const SKILL_BALLET = 'Ballet';
const SKILL_BALLROOM = 'Ballroom';
const SKILL_BREAKDANCING = 'Breakdancing';
const SKILL_CONTEMPORARY = 'Contemporary';
const SKILL_HIP_HOP = 'Hip Hop';
const SKILL_JAZZ = 'Jazz';
const SKILL_TAP = 'Tap';

const DANCE_LABEL = 'Dance';

const SKILLS_DANCE = [
  SKILL_BALLET,
  SKILL_BALLROOM,
  SKILL_BREAKDANCING,
  SKILL_CONTEMPORARY,
  'Dance- Other',
  SKILL_HIP_HOP,
  SKILL_JAZZ,
  SKILL_TAP,
];

const SKILLS_DANCE_UK = [
  SKILL_BALLET,
  SKILL_BALLROOM,
  SKILL_BREAKDANCING,
  SKILL_CONTEMPORARY,
  SKILL_HIP_HOP,
  SKILL_JAZZ,
  SKILL_TAP,
  'Other Dance',
];

const SKILLS_DANCE_CATEGORY = {
  label: DANCE_LABEL,
  list: SKILLS_DANCE,
};

const SKILLS_DANCE_CATEGORY_UK = {
  label: DANCE_LABEL,
  list: SKILLS_DANCE_UK,
};

// Experience
const SKILL_BARISTA = 'Barista';
const SKILL_BARTENDING = 'Bartending';
const SKILL_CATERING = 'Catering';
const SKILL_CHEF = 'Chef';
const SKILL_DJ = 'DJ';
const SKILL_DOCTOR = 'Doctor';
const SKILL_FENCING = 'Fencing';
const SKILL_FIREARMS = 'Firearms';
const SKILL_FIREFIGHTER = 'Firefighter';
const SKILL_LIFEGUARD = 'Lifeguard';
const SKILL_MANICURIST = 'Manicurist';
const SKILL_MILITARY_VETERAN = 'Military / Veteran';
const SKILL_MODEL = 'Model';
const SKILL_NURSING = 'Nursing';
const SKILL_PRECISION_DRIVING = 'Precision Driving';
const SKILL_STENOGRAPHER = 'Stenographer';
const SKILL_STUNTS = 'Stunts';
const SKILL_WAITING_TABLES = 'Waiting Tables';
const SKILL_WEAPONS = 'Weapons';

const EXPERIENCE_LABEL = 'Experience';

const SKILLS_EXPERIENCE = [
  SKILL_BARISTA,
  SKILL_BARTENDING,
  'Cab Driver',
  'Cameraman',
  SKILL_CATERING,
  SKILL_CHEF,
  SKILL_DJ,
  SKILL_DOCTOR,
  'EMT / Paramedic',
  SKILL_FENCING,
  SKILL_FIREARMS,
  SKILL_FIREFIGHTER,
  'Hairstylist',
  SKILL_LIFEGUARD,
  'Makeup Artist',
  SKILL_MANICURIST,
  'Massage Therapy',
  SKILL_MILITARY_VETERAN,
  SKILL_MODEL,
  SKILL_NURSING,
  SKILL_PRECISION_DRIVING,
  SKILL_STENOGRAPHER,
  SKILL_STUNTS,
  SKILL_WAITING_TABLES,
  SKILL_WEAPONS,
];

const SKILLS_EXPERIENCE_UK = [
  SKILL_BARISTA,
  SKILL_BARTENDING,
  'Camera Operator',
  SKILL_CATERING,
  SKILL_CHEF,
  SKILL_DJ,
  SKILL_DOCTOR,
  SKILL_FENCING,
  SKILL_FIREARMS,
  SKILL_FIREFIGHTER,
  'Hairdresser',
  SKILL_LIFEGUARD,
  'Make-up Artist',
  SKILL_MANICURIST,
  'Massage Therapist',
  SKILL_MILITARY_VETERAN,
  SKILL_MODEL,
  SKILL_NURSING,
  'Paramedic',
  SKILL_PRECISION_DRIVING,
  SKILL_STENOGRAPHER,
  SKILL_STUNTS,
  'Taxi Driver',
  SKILL_WAITING_TABLES,
  SKILL_WEAPONS,
];

const SKILLS_EXPERIENCE_CATEGORY = {
  label: EXPERIENCE_LABEL,
  list: SKILLS_EXPERIENCE,
};

const SKILLS_EXPERIENCE_CATEGORY_UK = {
  label: EXPERIENCE_LABEL,
  list: SKILLS_EXPERIENCE_UK,
};

// Music
const SKILLS_MUSIC = [
  'Drums',
  'Guitar',
  'Marching Band',
  'Mariachi',
  'Orchestra',
  'Other Instrument',
  'Piano',
];

const SKILLS_MUSIC_CATEGORY = {
  label: 'Music',
  list: SKILLS_MUSIC,
};

// Performative
const PERFORMATIVE_AERIAL = 'Aerial';
const PERFORMATIVE_BELLY_DANCING = 'Belly Dancing';
const PERFORMATIVE_BURLESQUE = 'Burlesque';
const PERFORMATIVE_CASINO_DEALER = 'Casino Dealer';
const PERFORMATIVE_CLOWN = 'Clown';
const PERFORMATIVE_CONTORTION = 'Contortion';
const PERFORMATIVE_JUGGLING = 'Juggling';
const PERFORMATIVE_MAGICIAN = 'Magician';
const PERFORMATIVE_MIME = 'Mime';
const PERFORMATIVE_POLE_DANCING = 'Pole Dancing';
const PERFORMATIVE_STILT_WALKER = 'Stilt Walker';
const PERFORMATIVE_UNICYCLE = 'Unicycle';

const PERFORMATIVE_LABEL = 'Performative';

const SKILLS_PERFORMATIVE = [
  PERFORMATIVE_AERIAL,
  PERFORMATIVE_BELLY_DANCING,
  PERFORMATIVE_BURLESQUE,
  PERFORMATIVE_CASINO_DEALER,
  PERFORMATIVE_CLOWN,
  PERFORMATIVE_CONTORTION,
  'Flare Bartending',
  PERFORMATIVE_JUGGLING,
  PERFORMATIVE_MAGICIAN,
  PERFORMATIVE_MIME,
  PERFORMATIVE_POLE_DANCING,
  PERFORMATIVE_STILT_WALKER,
  'Theater',
  PERFORMATIVE_UNICYCLE,
];

const SKILLS_PERFORMATIVE_UK = [
  PERFORMATIVE_AERIAL,
  PERFORMATIVE_BELLY_DANCING,
  PERFORMATIVE_BURLESQUE,
  PERFORMATIVE_CASINO_DEALER,
  PERFORMATIVE_CLOWN,
  PERFORMATIVE_CONTORTION,
  'Flair Bartending',
  PERFORMATIVE_JUGGLING,
  PERFORMATIVE_MAGICIAN,
  PERFORMATIVE_MIME,
  PERFORMATIVE_POLE_DANCING,
  PERFORMATIVE_STILT_WALKER,
  'Theatre',
  PERFORMATIVE_UNICYCLE,
];

const SKILLS_PERFORMATIVE_CATEGORY = {
  label: PERFORMATIVE_LABEL,
  list: SKILLS_PERFORMATIVE,
};

const SKILLS_PERFORMATIVE_CATEGORY_UK = {
  label: PERFORMATIVE_LABEL,
  list: SKILLS_PERFORMATIVE_UK,
};

// Sport
const SPORT_ARCHERY = 'Archery';
const SPORT_BADMINTON = 'Badminton';
const SPORT_BASEBALL = 'Baseball';
const SPORT_BASKETBALL = 'Basketball';
const SPORT_BILLIARDS = 'Billiards';
const SPORT_BOWLING = 'Bowling';
const SPORT_BOXING = 'Boxing';
const SPORT_CHEERLEADING = 'Cheerleading';
const SPORT_CROSS_COUNTRY = 'Cross Country';
const SPORT_CYCLING = 'Cycling';
const SPORT_FOOTBALL = 'Football';
const SPORT_FRISBEE = 'Frisbee';
const SPORT_GOLF = 'Golf';
const SPORT_GYMNASTICS = 'Gymnastics';
const SPORT_HOCKEY = 'Hockey';
const SPORT_ICE_SKATING = 'Ice Skating';
const SPORT_JUMP_ROPE = 'Jump Rope';
const SPORT_KAYAKING = 'Kayaking';
const SPORT_MARTIAL_ARTS = 'Martial Arts';
const SPORT_MMA = 'MMA';
const SPORT_PARKOUR = 'Parkour';
const SPORT_PICKLEBALL = 'Pickleball';
const SPORT_PING_PONG = 'Ping Pong';
const SPORT_RUGBY = 'Rugby';
const SPORT_SCUBA_DIVING = 'Scuba Diving';
const SPORT_SKATEBOARDING = 'Skateboarding';
const SPORT_SKIING_SNOW = 'Skiing - Snow';
const SPORT_SKIING_WATER = 'Skiing - Water';
const SPORT_SNOWBOARDING = 'Snowboarding';
const SPORT_SOFTBALL = 'Softball';
const SPORT_SURFING = 'Surfing';
const SPORT_SWIMMING = 'Swimming';
const SPORT_TENNIS = 'Tennis';
const SPORT_TRACK = 'Track';
const SPORT_VOLLEYBALL = 'Volleyball';
const SPORT_WRESTLING = 'Wrestling';
const SPORT_YOGA = 'Yoga';

const SPORT_LABEL = 'Sport';

const SKILLS_SPORT = [
  SPORT_ARCHERY,
  SPORT_BADMINTON,
  SPORT_BASEBALL,
  SPORT_BASKETBALL,
  SPORT_BILLIARDS,
  'Body Building',
  SPORT_BOWLING,
  SPORT_BOXING,
  SPORT_CHEERLEADING,
  SPORT_CROSS_COUNTRY,
  'Crossfit',
  SPORT_CYCLING,
  SPORT_FOOTBALL,
  SPORT_FRISBEE,
  SPORT_GOLF,
  SPORT_GYMNASTICS,
  SPORT_HOCKEY,
  'Horseback Riding',
  SPORT_ICE_SKATING,
  'Jiujitsu',
  SPORT_JUMP_ROPE,
  SPORT_KAYAKING,
  'Kick Boxing',
  SPORT_MARTIAL_ARTS,
  SPORT_MMA,
  'Paddle Boarding',
  SPORT_PARKOUR,
  SPORT_PICKLEBALL,
  SPORT_PING_PONG,
  'Rock Climber',
  'Roller Blading',
  'Roller Skating',
  SPORT_RUGBY,
  SPORT_SCUBA_DIVING,
  SPORT_SKATEBOARDING,
  SPORT_SKIING_SNOW,
  SPORT_SKIING_WATER,
  SPORT_SNOWBOARDING,
  'Soccer',
  SPORT_SOFTBALL,
  SPORT_SURFING,
  SPORT_SWIMMING,
  SPORT_TENNIS,
  SPORT_TRACK,
  SPORT_VOLLEYBALL,
  SPORT_WRESTLING,
  SPORT_YOGA,
];

const SKILLS_SPORT_UK = [
  'American Football',
  SPORT_ARCHERY,
  SPORT_BADMINTON,
  SPORT_BASEBALL,
  SPORT_BASKETBALL,
  SPORT_BILLIARDS,
  'Bodybuilding',
  SPORT_BOWLING,
  SPORT_BOXING,
  SPORT_CHEERLEADING,
  SPORT_CROSS_COUNTRY,
  'CrossFit',
  SPORT_CYCLING,
  SPORT_FOOTBALL,
  SPORT_FRISBEE,
  SPORT_GOLF,
  SPORT_GYMNASTICS,
  SPORT_HOCKEY,
  'Horse Riding',
  SPORT_ICE_SKATING,
  'Jiu-Jitsu',
  SPORT_JUMP_ROPE,
  SPORT_KAYAKING,
  'Kickboxing',
  SPORT_MARTIAL_ARTS,
  SPORT_MMA,
  'Paddleboarding',
  SPORT_PARKOUR,
  SPORT_PICKLEBALL,
  SPORT_PING_PONG,
  'Rock Climbing',
  'Rollerblading',
  'Roller Skating',
  SPORT_RUGBY,
  SPORT_SCUBA_DIVING,
  SPORT_SKATEBOARDING,
  SPORT_SKIING_SNOW,
  SPORT_SKIING_WATER,
  SPORT_SNOWBOARDING,
  SPORT_SOFTBALL,
  SPORT_SURFING,
  SPORT_SWIMMING,
  SPORT_TENNIS,
  SPORT_TRACK,
  SPORT_VOLLEYBALL,
  SPORT_WRESTLING,
  SPORT_YOGA,
];

const SKILLS_SPORT_CATEGORY = {
  label: SPORT_LABEL,
  list: SKILLS_SPORT,
};

const SKILLS_SPORT_CATEGORY_UK = {
  label: SPORT_LABEL,
  list: SKILLS_SPORT_UK,
};

// Languages

const SKILLS_LANGUAGE = [
  'Arabic',
  'Bengali',
  'Chinese',
  'Czech',
  'Dutch',
  'English',
  'Farsi',
  'French',
  'German',
  'Greek',
  'Haitian Creole French',
  'Hindi',
  'Indo-Iranian',
  'Italian',
  'Japanese',
  'Javanese',
  'Korean',
  'North Germanic',
  'Panjabi',
  'Polish',
  'Portuguese',
  'Romanian',
  'Russian',
  'Sign Language',
  'Spanish',
  'Tagalog',
  'Thai',
  'Turkish',
  'Ukrainian',
  'Urdu',
  'Vietnamese',
  'Language - Other',
];

const SKILLS_LANGUAGE_CATEGORY = {
  label: 'Languages',
  list: SKILLS_LANGUAGE,
};

const SKILLS_CATEGORIES = [
  SKILLS_ART_CATEGORY,
  SKILLS_DANCE_CATEGORY,
  SKILLS_EXPERIENCE_CATEGORY,
  SKILLS_MUSIC_CATEGORY,
  SKILLS_PERFORMATIVE_CATEGORY,
  SKILLS_SPORT_CATEGORY,
  SKILLS_LANGUAGE_CATEGORY,
];

const SKILLS_CATEGORIES_UK = [
  SKILLS_ART_CATEGORY_UK,
  SKILLS_DANCE_CATEGORY_UK,
  SKILLS_EXPERIENCE_CATEGORY_UK,
  SKILLS_MUSIC_CATEGORY,
  SKILLS_PERFORMATIVE_CATEGORY_UK,
  SKILLS_SPORT_CATEGORY_UK,
  SKILLS_LANGUAGE_CATEGORY,
];

export const SKILLS_CATEGORIES_DETAILED: AssetCategoryWithElementsType[] =
  SKILLS_CATEGORIES.map(({ label, list }) => ({
    label,
    list,
  }));

export const SKILLS_CATEGORIES_DETAILED_UK: AssetCategoryWithElementsType[] =
  SKILLS_CATEGORIES_UK.map(({ label, list }) => ({
    label,
    list,
  }));
